import store from "@/store";

const router = [
  {
    path: "/instansi/:instansi_id/instansi/detail",
    name: "instansi.detail",
    meta: {
      auth: true
    },
    component: () => import("./pages/Detail.vue")
  },
  {
    path: "/403dapodik",
    name: "403dapodik",
    meta: {
      auth: false
    },
    component: () => import("./components/403Dapodik.vue")
  },
  {
    path: "/daftar-instansi",
    name: "instansi.pilih",
    meta: {
      auth: true
    },
    component: () => import("./pages/PilihInstansi"),
    beforeEnter: (to, from, next) => {
      store.dispatch("instansi/get").then(res => {
        var u = store.getters["user/user"];
        var checkDefInstansi = res.filter(seri => seri.is_default == 1);
        // route default highlight subseri
        if (!u.is_super_admin && checkDefInstansi.length > 0 && checkDefInstansi[0].kode === "paud") {
          if (from.name) {
            next();
          } else {
            next({
              name: "instansi.pilih.sub",
              params: { parent_id: checkDefInstansi[0].id }
            });
          }
        }
        // route default higtlight seri
        else if (!u.is_super_admin && checkDefInstansi.length > 0) {
          if (from.name) {
            next();
          } else {
            next({
              name: "beranda",
              params: { instansi_id: checkDefInstansi[0].id }
            });
          }
        } else {
          next();
        }
      });
    }
  },
  {
    path: "/seri-sebelumnya",
    name: "instansi.archieve",
    meta: {
      auth: true
    },
    component: () => import("./pages/PilihInstansiArchieve"),
    beforeEnter: (to, from, next) => {
      store.dispatch("instansi/get").then(res => {
        var u = store.getters["user/user"];
        var checkDefInstansi = res.filter(seri => seri.is_default == 1);
        // route default highlight subseri
        if (!u.is_super_admin && checkDefInstansi.length > 0 && checkDefInstansi[0].kode === "paud") {
          if (from.name) {
            next();
          } else {
            next({
              name: "instansi.pilih.sub",
              params: { parent_id: checkDefInstansi[0].id }
            });
          }
        }
        // route default higtlight seri
        else if (!u.is_super_admin && checkDefInstansi.length > 0) {
          if (from.name) {
            next();
          } else {
            next({
              name: "beranda",
              params: { instansi_id: checkDefInstansi[0].id }
            });
          }
        } else {
          next();
        }
      });
    }
  },
  {
    path: "/sub-instansi/:parent_id",
    name: "instansi.pilih.sub",
    meta: {
      auth: true
    },
    component: () => import("./pages/PilihSubInstansi")
  },
  {
    path: "/kelola",
    name: "instansi.pilih.admin",
    meta: {
      auth: true
    },
    component: () => import("./pages/PilihInstansiAdmin")
  }
];

export default router;
